import React, { useContext, useEffect } from 'react';
import { FormContext } from '../common/form/FormContext';
import { useStepper } from '../common/components/StepperContext';
import { RESOURCE_FIELD_NAMES, RESOURCE_TYPE } from '../resource/common/resourceConstants';
import ResourceFormItems from '../resource/common/resourceFormItems/ResourceFormItems';
import { isEqual } from 'lodash';

export default () => {
    const { state, validation, handleChange } = useContext(FormContext);
    const { setStepData, setStepCompletion, activeStep, getStepData } = useStepper();

    const isCrewOrCast = [RESOURCE_TYPE.cast, RESOURCE_TYPE.crew].includes(state?.type);

    useEffect(() => {
        setStepCompletion(activeStep, validation?.isValid);
    }, [validation?.isValid]);

    useEffect(() => {
        const currentData = getStepData(activeStep);
        if (!isEqual(currentData, state)) {
            setStepData(activeStep, state);
        }
    }, [state]);

    const hiddenFields = {
        [RESOURCE_FIELD_NAMES.hiringInfoSection]: true,
        [RESOURCE_FIELD_NAMES[isCrewOrCast ? RESOURCE_FIELD_NAMES.resourceCategory : RESOURCE_FIELD_NAMES.role]]: true
    };

    return <ResourceFormItems disabledFields={{ [RESOURCE_FIELD_NAMES.type]: true }} hiddenFields={hiddenFields} />;
};
